import messages from './messages'

let locale = window.location.pathname.replace(/^\/([^\/]+).*/i, '$1');

// 如果链接有携带参数
// 检测是否和参数匹配的语言版本
// 重置本地语言版本
if (locale && locale != '/' && messages[locale]) {
    localStorage.setItem('locale', locale);
} else {
    localStorage.setItem('locale', 'zh-CN');
}

export default {
    locale: locale && locale != '/' && messages[locale] ? locale : 'zh',
    base: locale && locale != '/' && messages[locale] ? (locale == 'zh' ? '' : locale) : ''
}